module.exports = __webpack_public_path__ + "static/img/img-example.425f6f3b.png";